import { render, staticRenderFns } from "./TagMultiselectRequest.vue?vue&type=template&id=989ec54a"
import script from "./TagMultiselectRequest.vue?vue&type=script&lang=ts"
export * from "./TagMultiselectRequest.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('989ec54a')) {
      api.createRecord('989ec54a', component.options)
    } else {
      api.reload('989ec54a', component.options)
    }
    module.hot.accept("./TagMultiselectRequest.vue?vue&type=template&id=989ec54a", function () {
      api.rerender('989ec54a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/TagMultiselectRequest.vue"
export default component.exports